type Environment = 'development' | 'production'
function resolveEnv(): Environment {
  try {
    const hostname = window.location.hostname

    if (hostname === 'app.buncheck.com') {
      return 'production'
    }

    return 'development'
  } catch (e) {
    console.error(e)
    return 'development'
  }
}

export const env = resolveEnv()
